/* import __COLOCATED_TEMPLATE__ from './loading-services.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './loading-services.module.scss';

@classic
@classNames(styles.component)
export default class RequestStepsLoadingLoadingServices extends Component {}
